import "./style.scss";
import * as React from "react";
import { FlyerImage } from "./FlyerImage";
import { FlyerItemRectangle } from "./FlyerItemRectangle";
import { FlyerPage, FlyerItem } from "./types";

interface GradientFunction {
  (value: any): string;
}

interface HeatmapImageProps {
  page: FlyerPage;
  resolution: "high" | "med" | "low";
  items: FlyerItem[];
  metric: string;
  gradient: GradientFunction;
  pageRef?: (el: any) => void;
  id: string;
}

export class HeatmapImage extends React.Component<HeatmapImageProps, any> {
  constructor() {
    super();
    this.state = {
      scale: null,
      imageId: null
    };
  }

  componentDidMount() {
    this.setState({
      imageId: `${this.props.id}-flyer-image-${this.props.page.page}`
    });
    window.addEventListener("resize", this.calculateScale);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.calculateScale);
  }

  /* The high-res flyer images all have a fixed width, but we are 
  resizing them into a container of fixed height. Because of this,
  we have to load the image and get the loaded width before we 
  can calculate the scale */
  calculateScale = () => {
    let scale = null;
    const img = document.getElementById(this.state.imageId);
    if (!img) return;
    else if (this.props.resolution === "high") {
      const originalWidth = this.props.page.right - this.props.page.left;
      scale = img.clientWidth / originalWidth;
    } else {
      /* Flyers have the origin (0, 0) in the top left corner, and so 
      the bottom of the flyer is negative in the y axis. Make it 
      positive to work with SVG's coordinate system. */
      const originalHeight = -1 * this.props.page.bottom;
      scale = img.clientHeight / originalHeight;
    }
    this.setState({ scale: scale });
  };

  renderItemBoxes = () => {
    if (!this.props.items[0] || !this.state.scale) return null;
    return this.props.items.map((item: FlyerItem) => {
      const colour = this.props.gradient(item[this.props.metric]);
      return (
        <FlyerItemRectangle
          key={item.orig_flyer_item_id}
          scale={this.state.scale}
          item={item}
          page={this.props.page}
          metric={this.props.metric}
          colour={colour}
        />
      );
    });
  };

  render() {
    return (
      <div className="heatmap-image" ref={this.props.pageRef || null}>
        <FlyerImage
          page={this.props.page}
          onLoad={this.calculateScale}
          resolution={this.props.resolution}
          id={this.state.imageId}
        />
        <div>{this.renderItemBoxes()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/HeatmapImage.tsx